import { t } from 'i18next';

export type UpgradeModules = 'thermalComfort' | 'health' | 'moreModules';

export const upgradeModuleDescriptions: Record<UpgradeModules, {
  title: string;
  subTitle: string;
  buttonLabel: string;
  description: string;
}> = {
  thermalComfort: {
    buttonLabel: t('contratarModulo'),
    description: t('contrateModuloComecarUsar'),
    subTitle: t('acompanheConfortoTermicoParque'),
    title: t('confortoTermico'),
  },
  health: {
    buttonLabel: t('contratarModulo'),
    description: t('contrateModuloComecarUsar'),
    subTitle: t('acompanheSaudeMaquinasParque'),
    title: t('saudeMaquinas'),
  },
  moreModules: {
    buttonLabel: t('entrarEmContato'),
    description: t('entreContatoDielModulosSeuNegocio'),
    subTitle: t('acompanheInformacoesCompletasParque'),
    title: t('maisModulos'),
  },
};

export const COMERCIAL_EMAIL = 'comercial@dielenergia.com';
